export default "/fonts/vendor/@fontsource/lato/files/lato-latin-ext-300-normal.woff?20e6fb37e331fe8bb43e71812c975b8b";